export  class BaseModel {
	id: number;
	deleted: boolean;
	createdAt: string;
	updatedAt: string;
}
